<template>
  <er-data-tables
    class="card-all-ponds-table"
    :key="$i18n.locale"
    :tableData="tablePonds"
    :columns="selectedHeaders"
    :el-table-props="tableProps"
    :action-column="false"
    uniqueId="pond-info-table"
    type="white-header-table"
    layout="table"
    v-loading="loading || tableLoading"
    ref="pondInfotable"
    @row-click="handleRowClick"
  >
    <template v-slot:title_header="{ header }">
      <span>{{ header.label }}</span>
    </template>
    <template v-slot:title="{ row }">{{ row.data.title }}</template>
    <template v-slot:days_of_cultivation_header="{ header }">
      <span>{{ header.label }}</span>
      <span class="header-sub-label">({{ header.sub_label }})</span>
    </template>
    <template v-slot:days_of_cultivation="{ row }">
      {{ row.data.days_of_cultivation }}
    </template>
    <template v-slot:abw_header="{ header }">
      <span>{{ header.label }}</span>
      <span class="header-sub-label">({{ header.sub_label }})</span>
      <span>
        <i class="el-icon-plus" @click="abwnested"></i>
      </span>
    </template>
    <template v-slot:abw_NestedColumn>
      <template v-for="index in abwShowintialCol">
        <el-table-column
          :key="index"
          :min-width="55 + 12 * abwShowColOffset"
          align="left"
        >
          <template slot-scope="{ row }">
            <el-col
              tag="p"
              :title="
                getPondIdToLatestNABWValues[row._id][
                  index + abwShowColOffset - 1
                ].abw == 0
                  ? ''
                  : getFormattedDate(
                      getPondIdToLatestNABWValues[row._id][
                        index + abwShowColOffset - 1
                      ].date
                    )
              "
              :style="`text-align:left`"
              :class="`abw-${index + abwShowColOffset}`"
            >
              {{
                getPondIdToLatestNABWValues[row._id][
                  index + abwShowColOffset - 1
                ].abw
                  | numberWithNDigitPrecision
                  | na("-", true)
              }}
            </el-col>
          </template>
        </el-table-column>
      </template>
    </template>
    <template v-slot:biomass_header="{ header }">
      <span>{{ header.label }}</span>
      <span class="header-sub-label">({{ header.sub_label }})</span>
    </template>
    <template v-slot:biomass="{ row }">
      <el-row class="cell-container">
        <p>
          {{ row.data.biomass | kgs | commas(userCountryCode) | na("-", true) }}
        </p>
      </el-row>
    </template>
    <template v-slot:do_header="{ header }">
      <span>{{ header.label }}</span>
      <span class="header-sub-label">({{ header.sub_label }})</span>
    </template>
    <template v-slot:do="{ row }">
      <el-popover
        v-if="getPondIdToLatestNDOTempValues[row.data._id][0].do"
        placement="top-start"
        width="200"
        trigger="hover"
        popper-class="do-pop-container"
        @after-enter="onHover(getPondIdToLatestNDOTempValues[row.data._id])"
      >
        <div>
          <el-row
            class="do-last-date"
            v-loading="lastDoDateLoading"
            element-loading-spinner="el-icon-loading"
          >
            {{ $t("Comn_time") }}:
            <span>{{ getDoDateSince | na("-") }}</span>
          </el-row>
          <p class="do-hours-label">{{ $t("Comn_last") }} 3 {{ $t("Hrs") }}</p>
          <div>
            <img
              v-if="getDoInDateRange.length > 0"
              src="@/assets/pond-info/down-arrow.svg"
              atl="down arrow"
              style="float:right; margin-bottom: 2px;"
            />
            <div class="row__bar-container">
              <!-- <high-charts :options="getChartOptions" ref="highcharts" constructor-type="stockChart"></high-charts> -->
              <el-row
                class="bar"
                v-loading="doDateRangeLoading"
                element-loading-spinner="el-icon-loading"
              >
                <template v-if="getDoInDateRange.length > 0">
                  <div
                    v-for="(item, index) in getDoInDateRange"
                    :key="`${item.color}${index}`"
                    class="bar__filler"
                    :style="
                      getBarStyling(index, getDoInDateRange.length, item.color)
                    "
                  ></div>
                </template>
                <el-tag v-else>{{ $t("Comn_no_data") }}</el-tag>

                <!-- <div class="bar__filler" :style="`width:${100}px; background: green`"></div> -->
              </el-row>
            </div>
          </div>
        </div>
        <div style="display: flex" slot="reference">
          <template
            v-for="(device, index) in getPondIdToLatestNDOTempValues[
              row.data._id
            ]"
          >
            <el-col tag="p" :key="index" :style="generateColorForDo(device)">{{
              device.do | numberWithNDigitPrecision(1) | na("-", true)
            }}</el-col>
          </template>
        </div>
      </el-popover>
      <div style="display: flex" v-else>
        <template
          v-for="(device, index) in getPondIdToLatestNDOTempValues[
            row.data._id
          ]"
        >
          <el-col tag="p" :key="index" :style="generateColorForDo(device)">{{
            device.do | numberWithNDigitPrecision(1) | na("-", true)
          }}</el-col>
        </template>
      </div>
    </template>
    <template v-slot:temp_header="{ header }">
      <span>{{ header.label }}</span>
      <span class="header-sub-label">({{ header.sub_label }})</span>
    </template>
    <template v-slot:temp="{ row }">
      <el-popover
        v-if="getPondIdToLatestNDOTempValues[row.data._id][0].temp"
        placement="top-start"
        width="200"
        trigger="hover"
        popper-class="do-pop-container"
        @after-enter="onTempHover(getPondIdToLatestNDOTempValues[row.data._id])"
      >
        <div>
          <el-row
            class="do-last-date"
            v-loading="lastDoDateLoading"
            element-loading-spinner="el-icon-loading"
          >
            {{ $t("Comn_time") }}:
            <span>{{ getDoDateSince | na("-") }}</span>
          </el-row>
          <p class="do-hours-label">{{ $t("Comn_last") }} 3 {{ $t("Hrs") }}</p>
          <div>
            <img
              v-if="getDoInDateRange.length > 0"
              src="@/assets/pond-info/down-arrow.svg"
              atl="down arrow"
              style="float:right; margin-bottom: 2px;"
            />
            <div class="row__bar-container">
              <!-- <high-charts :options="getChartOptions" ref="highcharts" constructor-type="stockChart"></high-charts> -->
              <el-row
                class="bar"
                v-loading="doDateRangeLoading"
                element-loading-spinner="el-icon-loading"
              >
                <template v-if="getDoInDateRange.length > 0">
                  <div
                    v-for="(item, index) in getDoInDateRange"
                    :key="`${item.color}${index}`"
                    class="bar__filler"
                    :style="
                      getBarStyling(index, getDoInDateRange.length, item.color)
                    "
                  ></div>
                </template>
                <el-tag v-else>{{ $t("Comn_no_data") }}</el-tag>

                <!-- <div class="bar__filler" :style="`width:${100}px; background: green`"></div> -->
              </el-row>
            </div>
          </div>
        </div>
        <div style="display: flex" slot="reference">
          <template
            v-for="(device, index) in getPondIdToLatestNDOTempValues[
              row.data._id
            ]"
          >
            <el-col tag="p" :key="index" :style="generateColorForTemp(device)">
              {{ device.temp | numberWithNDigitPrecision(1) | na("-", true) }}
            </el-col>
          </template>
        </div>
      </el-popover>
      <div style="display: flex" v-else>
        <template
          v-for="(device, index) in getPondIdToLatestNDOTempValues[
            row.data._id
          ]"
        >
          <el-col tag="p" :key="index" :style="generateColorForDo(device)">{{
            device.do | numberWithNDigitPrecision(1) | na("-", true)
          }}</el-col>
        </template>
      </div>
    </template>
    <template v-slot:total_feed_header="{ header }">
      <er-text-tag
        :text-to-scroll="`${header.label} ${header.sub_label}`"
        :threshold-characters="16"
      >
        <span>{{ header.label }}</span>
        <span class="header-sub-label">({{ header.sub_label }})</span>
      </er-text-tag>
    </template>
    <template v-slot:total_feed="{ row }">
      <el-row type="flex">
        <p>
          {{
            Math.round(row.data.total_dispensed_feed)
              | commas(userCountryCode)
              | na
          }}
        </p>
        &nbsp;
        <span :style="generateColorForNetFeed(row.data)" class="second-value"
          >({{ Math.round(row.data.dispensed_feed) | na }})</span
        >
      </el-row>
    </template>
    <template v-slot:mode_header="{ header }">
      <span>{{ header.label }}</span>
    </template>
    <template v-slot:mode="{ row }">
      <!-- <div class="cell-container"> -->
      <span :style="generateColorForMode(row.data)">{{ mode(row.data) }}</span>
      <!-- </div> -->
    </template>
    <template v-slot:survival_percentage_header="{ header }">
      <span>{{ header.label }}</span>
    </template>
    <template v-slot:survival_percentage="{ row }">
      <div>
        <span class="cell-container column">
          <p
            :style="
              `color:${getProgressBarColor(row.data.survival_percentage)}`
            "
          >
            {{ row.data.survival_percentage | numberWithNDigitPrecision(1) }}%
          </p>
        </span>
      </div>
    </template>
    <template v-slot:post_larva_stocked="{ row }">
      <span>{{
        row.data.post_larva_stocked | commas(userCountryCode) | na("-", true)
      }}</span>
    </template>
    <template v-slot:size_header="{ header }">
      <er-text-tag
        :text-to-scroll="`${header.label} ${header.sub_label}`"
        :threshold-characters="16"
      >
        <span>{{ header.label }}</span>
        <span class="header-sub-label">({{ header.sub_label }})</span>
      </er-text-tag>
    </template>
    <template v-slot:size="{ row }">
      {{
        updatePondSizeBasedOnUnits(row.data.size, row.data.area_units)
          | numberWithNDigitPrecision(2)
      }}
    </template>
  </er-data-tables>
</template>

<script>
import errorHandlerMixin from "@/mixins/errorHandlerMixin.js";
import redirectsMixin from "@/mixins/redirectsMixin.js";
import filtersMixin from "@/mixins/filtersMixin.js";
import { castISOStringToUserTZ } from "@/utils/commonUtils";
import { mapActions, mapGetters } from "vuex";
import Pond from "@/model/pond";

export default {
  name: "AllPondsTable",
  mixins: [errorHandlerMixin, redirectsMixin, filtersMixin],
  data: function() {
    return {
      // pondHealthData: [],
      numbers: [],
      params: {
        get_all: true,
        status: ["ACTIVE"]
      },
      activeName: "first",
      testData: [
        { do: 12, color: "orange" },
        { do: 34, color: "green" },
        { do: 1, color: "red" }
      ],
      lastDoDateLoading: true,
      doDateRangeLoading: true,
      abwShowintialCol: 1,
      abwShowColOffset: 3,
      tableLoading: false,
      dateFormat: "DD-MM-YYYY"
    };
  },
  props: {
    filteredPonds: Array,
    loading: Boolean,
    selectedHeaders: Object,
    userCountryCode: { type: String, default: "IN" }
  },
  filters: {
    survival(value) {
      if (value) {
        return `${Math.round(value)}%`;
      } else {
        return undefined;
      }
    },
    lakhs(value) {
      const stockStr = (value / 100000).toFixed(1);
      return stockStr;
    },
    tonnes(value) {
      const stockStr = (value / 1000).toFixed(1);
      const dec = stockStr.split(".")[1];

      if (parseInt(dec) > 0) {
        return stockStr;
      } else {
        return stockStr.split(".")[0];
      }
    },
    kgs(value) {
      return Math.round(value);
    }
  },

  computed: {
    ...mapGetters("pondInfo", {
      selectedPondIds: "selectedPondIds",
      selectedPonds: "selectedPonds",
      getPondIdToLatestNABWValues: "getPondIdToLatestNABWValues",
      getPondIdToLatestNDOTempValues: "getPondIdToLatestNDOTempValues",
      getSummaryOfLatestDOTemp: "getSummaryOfLatestDOTemp",
      getSummaryOfLatestNABWValues: "getSummaryOfLatestNABWValues",
      getDoRangeStartDate: "getDoRangeStartDate",
      getDoInDateRange: "getDoInDateRange",
      getPondMode: "getPondMode"
    }),
    ...mapGetters("user", {
      getUserTimeZoneOffset: "getUserTimeZoneOffset",
      getUserProfile: "getUserProfile",
      getUserCountryName: "getUserCountryName"
    }),

    tablePonds() {
      return this.$lodash.cloneDeep(this.filteredPonds).map(x => {
        x.survival_percentage =
          x.status === "INACTIVE" ? 0 : x.survival_percentage || 100;
        return x;
      });
    },

    getRowNameFirst() {
      const row = this.data[Object.keys(this.data)[0]];
      return Object.keys(row[Object.keys(row)[0]])[0];
    },
    getRowNameSecond() {
      const row = this.data[Object.keys(this.data)[0]];
      return Object.keys(row[Object.keys(row)[0]])[1];
    },
    updatePondSizeBasedOnUnits() {
      return (size, units) => {
        const userLocation = this.getUserCountryName.toLowerCase();
        if (userLocation === "india") {
          return Number(
            this.$commonUtils.castPondAreaSize(size, units, "ac")
          ).toFixed(2);
        }
        return Number(
          this.$commonUtils.castPondAreaSize(size, units, "ha")
        ).toFixed(2);
      };
    },
    tableProps: function() {
      return {
        size: "mini",
        showSummary: true,
        rowClassName: this.rowClassName,
        summaryMethod: this.getSummaries,
        defaultSort: {
          prop: "title",
          order: "ascending"
        },
        hasNestedColumn: true
      };
    },
    getABWDates() {
      const today = this.$moment()
        .utcOffset(this.getUserTimeZoneOffset)
        .format("DD MMMM YYYY");
      const yesterday = this.$moment()
        .subtract(1, "days")
        // .startOf("day")
        .utcOffset(this.getUserTimeZoneOffset)
        .format("DD MMMM YYYY");
      // .toString();

      return {
        today,
        yesterday
      };
    },
    mode: function() {
      return data => {
        const value = this.getPondMode[data._id];
        if (value === "SHRIMP_TALK") {
          return this.$t("PM_automatic");
        } else if (value === "HYBRID") {
          return this.$t("hybrid");
        } else if (value === "FARMER") {
          return this.$t("Comn_schedule");
        } else if (value === "MANUAL") {
          return this.$t("PM_sch_mode4");
        } else if (value === "NO_PMS") {
          return "-";
        }
      };
    },
    getProgressBarColor() {
      return value => {
        return [
          { l: 0, h: 25, color: "#EB4841" },
          { l: 26, h: 50, color: "#F58949" },
          { l: 51, h: 75, color: "#FFC949" },
          { l: 76, h: 100, color: "#0C920C" }
        ].reduce((acc, curr) => {
          const mValue = Math.ceil(value);
          if (curr.l <= mValue && curr.h >= mValue) {
            acc = curr.color;
          }
          return acc;
        }, "#000000");
      };
    },
    getTitleForFeed() {
      return pondSummary => {
        return `${this.$t("Comn_manual_feed")}: ${
          pondSummary.manual_feed
        }\n${this.$t("Comn_pond_mother")}: ${
          pondSummary.schedule_dispensed_feed
        }`;
      };
    },
    feedDispensed() {
      return row => {
        const feedDispensed = this.toFixedAndParseFloat(
          row.feed_dispensed || 0
        );
        const feed = this.toFixedAndParseFloat(row.total_feed || 0);
        return `${Math.round(feedDispensed)}/${Math.round(feed)}`;
      };
    },
    generateColorForAWG() {
      return data => {
        const { awg } = data;
        if (awg < 0) {
          return { color: "Red" };
        } else if (awg > 0) {
          return { color: "Green" };
        } else {
          return { color: "Grey" };
        }
      };
    },
    generateColorForBiomass() {
      return data => {
        const { biomass, last_biomass } = data;
        const diff = (biomass - last_biomass) / 1000;
        if (diff < 0) {
          return { color: "Red" };
        } else if (diff >= 1) {
          return { color: "Green" };
        } else {
          return { color: "Grey" };
        }
      };
    },
    generateColorForNetFeed() {
      return data => {
        const { dispensed_feed } = data;
        if (dispensed_feed < 0) {
          return { color: "Red" };
        } else if (dispensed_feed > 0) {
          return { color: "Green" };
        } else {
          return { color: "Grey" };
        }
      };
    },
    generateColorForMode() {
      return data => {
        return Pond.generateColorForMode(this.getPondMode[data._id]);
      };
    },
    generateColorForDo() {
      return data => {
        if (data.do < data.doConfig.critical_lower_limit) {
          return { color: "red" };
        } else if (
          data.do >= data.doConfig.critical_lower_limit &&
          data.do < data.doConfig.lower_limit
        ) {
          return { color: "orange" };
        } else if (data.do >= data.doConfig.lower_limit) {
          return { color: "green" };
        } else {
          return { color: "black" };
        }
      };
    },
    generateColorForTemp() {
      return data => {
        // const { do } = data;
        const { tempConfig, temp } = data;
        const { lower_limit, upper_limit, tolerance } = tempConfig;

        if (temp >= lower_limit && temp <= upper_limit) {
          return { color: "green" };
        } else if (
          temp >= lower_limit - tolerance &&
          temp <= upper_limit + tolerance
        ) {
          return { color: "orange" };
        } else if (
          temp < lower_limit - tolerance ||
          temp > upper_limit + tolerance
        ) {
          return { color: "red" };
        } else {
          return { color: "black" };
        }
      };
    },
    getDoDateSince() {
      if (!this.getDoRangeStartDate) {
        return "";
      }

      const now = this.$moment().utcOffset(this.getUserTimeZoneOffset);
      const expiration = this.$moment
        .utc(
          castISOStringToUserTZ(
            this.getDoRangeStartDate,
            this.getUserTimeZoneOffset
          )
        )
        .utcOffset(this.getUserTimeZoneOffset);

      const diffDuration = this.$moment.duration(Math.abs(now - expiration));

      if (diffDuration.months() > 0) {
        return `${diffDuration.months()}m ${diffDuration.days()}d ${diffDuration.hours()}h ${diffDuration.minutes()}m`;
      } else if (diffDuration.days() > 0) {
        return `${diffDuration.days()}d ${diffDuration.hours()}h ${diffDuration.minutes()}m`;
      } else if (diffDuration.hours() > 0) {
        return `${diffDuration.hours()}h ${diffDuration.minutes()}m`;
      } else {
        return `${diffDuration.minutes()}m`;
      }
    }
  },
  methods: {
    ...mapActions("pondInfo", {
      changeSelectedPonds: "changeSelectedPonds",
      fetchDoRangeStartDate: "fetchDoRangeStartDate",
      fetchDoInDateRange: "fetchDoInDateRange"
    }),
    getFormattedDate(date) {
      return this.$moment.utc(date).format(this.dateFormat);
    },

    onHover: async function(row) {
      const { do: dissolved_oxygen, pgID, doConfig: config } = row[0];
      this.lastDoDateLoading = true;
      this.doDateRangeLoading = true;
      let params = {};
      if (dissolved_oxygen < config.critical_lower_limit) {
        params = {
          pond_guard_id: pgID,
          "range[min]": 0,
          "range[max]": config.critical_lower_limit,
          parameter: "dissolved_oxygen"
        };
      } else if (
        dissolved_oxygen >= config.critical_lower_limit &&
        dissolved_oxygen < config.lower_limit
      ) {
        params = {
          pond_guard_id: pgID,
          "range[min]": config.critical_lower_limit,
          "range[max]": config.lower_limit,
          parameter: "dissolved_oxygen"
        };
      } else {
        params = {
          pond_guard_id: pgID,
          "range[min]": config.lower_limit,
          parameter: "dissolved_oxygen"
        };
      }
      const doData = {
        pgID,
        config
      };
      try {
        await this.fetchDoRangeStartDate(params);
      } catch (err) {
        this.errorMessages(err, false);
        this.lastDoDateLoading = false;
      } finally {
        this.lastDoDateLoading = false;
      }

      try {
        await this.fetchDoInDateRange(doData);
      } catch (err) {
        this.errorMessages(err, false);
        this.doDateRangeLoading = false;
      } finally {
        this.doDateRangeLoading = false;
      }
    },
    onTempHover: async function(row) {
      const { temp, pgID, tempConfig: config } = row[0];
      const { lower_limit, upper_limit, tolerance } = config;
      const criticalLowerLimit = lower_limit - tolerance;
      const criticalUpperLimit = upper_limit + tolerance;
      this.lastDoDateLoading = true;
      this.doDateRangeLoading = true;

      let params = {};

      if (temp > lower_limit && temp <= upper_limit) {
        params = {
          pond_guard_id: pgID,
          "range[min]": lower_limit,
          "range[max]": upper_limit,
          parameter: "temperature"
        };
      } else if (temp > criticalLowerLimit && temp <= lower_limit) {
        params = {
          pond_guard_id: pgID,
          "range[min]": criticalLowerLimit,
          "range[max]": lower_limit,
          parameter: "temperature"
        };
      } else if (temp > upper_limit && temp <= criticalUpperLimit) {
        params = {
          pond_guard_id: pgID,
          "range[min]": upper_limit,
          "range[max]": criticalUpperLimit,
          parameter: "temperature"
        };
      } else if (temp < criticalLowerLimit) {
        params = {
          pond_guard_id: pgID,
          // "range[min]": lower_limit - tolerance,
          "range[max]": criticalLowerLimit,
          parameter: "temperature"
        };
      } else {
        params = {
          pond_guard_id: pgID,
          "range[min]": criticalUpperLimit,
          // "range[max]": upper_limit + tolerance,
          parameter: "temperature"
        };
      }
      const tempData = {
        pgID,
        config
      };
      try {
        await this.fetchDoRangeStartDate(params);
      } catch (err) {
        this.errorMessages(err, false);
        this.lastDoDateLoading = false;
      } finally {
        this.lastDoDateLoading = false;
      }
      try {
        await this.fetchDoInDateRange(tempData);
      } catch (err) {
        this.errorMessages(err, false);
        this.doDateRangeLoading = false;
      } finally {
        this.doDateRangeLoading = false;
      }
    },
    handleRowClick: async function(row, column, event) {
      this.tableLoading = true;
      if (this.selectedPondIds.indexOf(row._id) === -1) {
        if (this.selectedPondIds.length >= 5) {
          const error = {
            type: "FAIL_TO_SAVE",
            errors: [
              { message: "Please deselect one pond & select another pond" }
            ]
          };
          this.errorMessages(error, false);
          return;
        }
        const ponds = this.$lodash.cloneDeep(this.selectedPonds);
        ponds.push(row);
        await this.changeSelectedPonds({ selected_ponds: ponds });
      } else {
        const index = this.selectedPondIds.indexOf(row._id);
        const ponds = this.$lodash.cloneDeep(this.selectedPonds);
        ponds.splice(index, 1);
        await this.changeSelectedPonds({
          selected_ponds: ponds,
          deleted_pond: row
        });
      }
      this.tableLoading = false;
    },
    formatedNumericValue(value, countryCode) {
      return parseInt(value).toLocaleString(`en-${countryCode}`);
    },
    getBarStyling(index, length, color) {
      if (index === 0) {
        return `width:${200 / length}px; background: ${color}; 
         border-radius: 5px 0px 0px 5px`;
      } else if (index === length - 1) {
        return `width:${200 / length}px; background: ${color}; 
         border-radius: 0px 5px 5px 0px`;
      } else {
        return `width:${200 / length}px; background: ${color}`;
      }
    },
    rowClassName({ row, rowIndex }) {
      if (row && (this.selectedPondIds || []).indexOf(row._id) > -1) {
        return "selected-row";
      } else {
        return "";
      }
    },
    getWeightedAvg(list, multiplyer, base) {
      const weights = list.map(item => Number(item[multiplyer]));
      const baseList = list.map(item => Number(item[base]));

      if (
        !weights.every(value => isNaN(value)) ||
        !baseList.every(value => isNaN(value))
      ) {
        const total = list
          .map(item => item[multiplyer] * Number(item[base]))
          .reduce((a, b) => a + b, 0);
        const divisor = weights.reduce((a, b) => a + b, 0);

        return base === "abw"
          ? (total / divisor).toFixed(1)
          : Math.round(total / divisor);
      } else {
        return "-";
      }
    },

    getFCRSummary(list) {
      const netFeed = list.map(item => Number(item.total_dispensed_feed));
      const biomass = list.map(item => Number(item.biomass));
      const [totalNetFeed, totalBiomass] = [netFeed, biomass].map(x =>
        x.reduce((acc, curr) => {
          if (isNaN(curr)) return acc;
          acc += curr;
          return acc;
        }, 0)
      );
      if (totalNetFeed > 0 && totalBiomass > 0) {
        return (
          netFeed.reduce((a, b) => a + b, 0) /
          (biomass.reduce((a, b) => a + b, 0) || 1)
        ).toFixed(2);
      } else {
        return "-";
      }
    },
    getFeeds(list, attribute) {
      const values = list.map(item => Math.round(Number(item[attribute])));
      if (!values.every(value => isNaN(value))) {
        const sum = values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);

        return sum;
      } else {
        return "-";
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      const defaultSummaryCalculator = (column, index, formatterFunc) => {
        const sum = data.reduce((acc, item) => {
          const value = Number(item[column.property]);
          if (isNaN(value)) return acc;
          acc += Math.round(value);
          return acc;
        }, 0);
        if (sum > 0) {
          sums[index] =
            column.property === "size"
              ? sum.toFixed(2)
              : this.formatedNumericValue(sum, this.userCountryCode);
        } else {
          sums[index] = "-";
        }
      };

      columns.forEach((column, index) => {
        switch (column.property) {
          case "title":
            sums[index] = this.$t("Comn_total");
            break;
          case "biomass":
            defaultSummaryCalculator(column, index, this.formatedNumericValue);
            break;
          case "post_larva_stocked":
            defaultSummaryCalculator(column, index, this.formatedNumericValue);
            break;
          case "fcr":
            sums[index] = this.getFCRSummary(data);
            break;
          case "survival_percentage":
            sums[index] = `${this.getWeightedAvg(
              data,
              "post_larva_stocked",
              "survival_percentage"
            )}%`;
            break;
          case "total_feed":
            sums[index] = `${this.getFeeds(
              data,
              "total_dispensed_feed"
            )} (${this.getFeeds(data, "dispensed_feed")})`;
            break;
          case "size":
            defaultSummaryCalculator(column, index, val => val.toFixed(2));
            break;
          default:
            sums[index] = "-";
        }
      });

      return sums;
    },
    abwnested(event) {
      event.stopPropagation();
      this.abwShowintialCol = this.abwShowintialCol === 1 ? 4 : 1;
      this.abwShowColOffset = this.abwShowintialCol === 1 ? 3 : 0;
      event.target.classList.toggle("el-icon-minus");
      return this.abwShowintialCol;
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/mixins.scss";
.do-pop-container {
  .el-icon-loading {
    margin-top: 8px;
  }
  .do-last-date {
    @include responsiveProperty(
      font-size,
      $app_font_size_1,
      $app_font_size_2,
      $app_font_size_3
    );
    color: #979797;
    margin-bottom: 12px;
    span {
      color: black;
    }
  }
  .do-hours-label {
    color: #979797;
    @include responsiveProperty(
      font-size,
      $app_font_size_1,
      $app_font_size_2,
      $app_font_size_3
    );
  }
  .row__bar-container {
    .bar {
      width: 100%;
      position: relative;
      display: flex;
      align-items: center;
      color: black;
      &__filler {
        height: 6px;
        margin-right: 0px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
        // background: linear-gradient(225deg, #2d9cdb 0%, #155dbe 100%);
        // &:hover {
        //   background: linear-gradient(45deg, #2d9cdb 0%, #155dbe 100%);
        // }
      }
    }
  }
}
.card-all-ponds-table {
  margin-top: 10px;
  .el-progress {
    width: 100%;
  }
  .er-data-tables__header-row:nth-child(2) {
    display: none;
  }
  .el-col.el-col-24.abw-4 {
    color: #155dbe;
  }
  .selected-row {
    background: aliceblue;
  }
}
</style>
